import 'bootstrap';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { instance } from './axios';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from '@/router';
import NightOwlSelect from '@night-owl-elite/vue-select';
import VueDatePicker from '@vuepic/vue-datepicker';
import { setupWebSockets } from './websocket.js';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export default {
  install(app) {
    const { config } = app;

    app.use(pinia);
    setupWebSockets();
    app.use(router);
    app.use(NightOwlSelect);

    config.globalProperties.$axios = instance;
    app.component('font-awesome-icon', FontAwesomeIcon);
    app.component('v-select', NightOwlSelect);
    app.component('VueDatePicker', VueDatePicker);

  }
}
